// Rótulo das colunas de data do heatmap da Visão Detalhada do Acompanhamento de Previsão
// (#2009, item 8), compartilhado pela tabela da tela e pelo PDF.
// O back manda o eixo X como texto pronto, no formato ano-primeiro (`2026-09-13` ou
// `2026-09-13 00:00`), que não cabe na coluna: aqui vira `13/09/26` (e `13/09/26 00h` com hora).

const ISO_DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})(?:[T ]+(\d{1,2})(?::(\d{2}))?(?::(\d{2}))?(?:\.\d+)?)?\s*(?:Z|[+-]\d{2}(?::?\d{2})?)?$/;

const pad2 = (value: string) => value.padStart(2, '0');

function formatTime(hour: string, minute = '00', second = '00'): string {
  if (second !== '00') return `${pad2(hour)}:${minute}:${second}`;
  return minute === '00' ? `${pad2(hour)}h` : `${pad2(hour)}:${minute}`;
}

/**
 * `2026-09-13` -> `13/09/26`; `2026-09-13 00:00` / `2026-09-13T12:30:00Z` -> `13/09/26 00h` /
 * `13/09/26 12:30`. A hora é mantida (duas colunas do mesmo dia precisam de rótulos diferentes)
 * e lida do próprio texto, sem passar por `Date`, para o fuso não deslocar o dia.
 * Qualquer texto que não seja data (ex.: `28/08`, `D+1`) volta como veio.
 */
export default function formatHeatmapDateLabel(label: string): string {
  const match = ISO_DATE_TIME.exec(label.trim());
  if (!match) return label;
  const [, year, month, day, hour, minute, second] = match;
  const validDate = Number(month) >= 1 && Number(month) <= 12
    && Number(day) >= 1 && Number(day) <= 31;
  const validTime = Number(hour ?? 0) <= 23 && Number(minute ?? 0) <= 59
    && Number(second ?? 0) <= 59;
  if (!validDate || !validTime) return label;

  const date = `${day}/${month}/${year.slice(2)}`;
  return hour === undefined ? date : `${date} ${formatTime(hour, minute, second)}`;
}
